module.exports = __webpack_public_path__ + "media/images/socean-logo-d70ac708.svg";